var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ui-dialog",
    {
      ref: "dialog",
      staticClass: "media-editor-dialog",
      attrs: { closable: !_vm.isProcessing, large: "" },
      on: { open: _vm.setup },
    },
    [
      _c("template", { slot: "header" }, [
        _c("h6", { staticClass: "ui-title" }, [
          _vm._v(
            "Trim " + _vm._s(_vm.mediaItem.comment || _vm.mediaItem.title)
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("WebPlayer", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isProcessing,
            expression: "!isProcessing",
          },
        ],
        ref: "webPlayer",
        attrs: { "on-player-event": _vm.onPlayerEvent },
      }),
      _vm._v(" "),
      _vm.isProcessing
        ? _c("div", { staticClass: "processing-video-overlay" }, [
            _c("div", { staticClass: "processing-video-overlay__spinner" }, [
              _c("div", { staticClass: "ui-progress-dots" }, [
                _c("div", { staticClass: "bounce1" }),
                _vm._v(" "),
                _c("div", { staticClass: "bounce2" }),
                _vm._v(" "),
                _c("div", { staticClass: "bounce3" }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "processing-video-overlay__text" }, [
              _c("h2", { staticClass: "ui-title" }, [
                _vm._v("Processing media"),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "editor" },
        [
          _c("editor-timeline", {
            ref: "editorTimeline",
            attrs: {
              duration: _vm.duration,
              "mark-in-pos": _vm.markInPos,
              "mark-out-pos": _vm.markOutPos,
              "player-position": _vm.position,
            },
            on: {
              "update:markInPos": function ($event) {
                _vm.markInPos = $event
              },
              "update:mark-in-pos": function ($event) {
                _vm.markInPos = $event
              },
              "update:markOutPos": function ($event) {
                _vm.markOutPos = $event
              },
              "update:mark-out-pos": function ($event) {
                _vm.markOutPos = $event
              },
              goToPosition: function ($event) {
                return _vm.goToPosition($event)
              },
            },
          }),
          _vm._v(" "),
          _c("editor-controls", {
            ref: "editorControls",
            attrs: { "is-playing": _vm.isPlaying },
            on: {
              markIn: function ($event) {
                return _vm.markIn()
              },
              markOut: function ($event) {
                return _vm.markOut()
              },
              goToIn: function ($event) {
                return _vm.goToIn()
              },
              stepBackward: function ($event) {
                return _vm.stepBackward()
              },
              pause: function ($event) {
                return _vm.pause()
              },
              play: function ($event) {
                return _vm.play()
              },
              stepForward: function ($event) {
                return _vm.stepForward()
              },
              goToOut: function ($event) {
                return _vm.goToOut()
              },
            },
          }),
          _vm._v(" "),
          _c(
            "ui-dialog-footer",
            [
              _c("ui-checkbox", {
                attrs: {
                  label: "Delete original video",
                  tooltip: "Checking this will delete the original video",
                },
                model: {
                  value: _vm.deleteOriginal,
                  callback: function ($$v) {
                    _vm.deleteOriginal = $$v
                  },
                  expression: "deleteOriginal",
                },
              }),
              _vm._v(" "),
              _c("ui-confirm-button", {
                attrs: {
                  "confirm-text": "Confirm",
                  secondary: "",
                  text: "Apply",
                  tooltip: "Create a new video out of the selected range",
                },
                on: { click: _vm.trim },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isProcessing
            ? _c("div", { staticClass: "blocker-overlay" })
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }